import { render, staticRenderFns } from "./FormularioVazamentoSig.vue?vue&type=template&id=0ab768c5&scoped=true&"
import script from "./FormularioVazamentoSig.vue?vue&type=script&lang=js&"
export * from "./FormularioVazamentoSig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab768c5",
  null
  
)

export default component.exports